import React, { FormEvent, useState } from 'react';
import Modal from 'react-modal';

import './Setup.fiscalpop.dialog.scss';
import Input from '../Forms/Input';
import Loading from '../Animations/loadScreen';

import { useMutation } from '@apollo/client';

import { graphqlSchema } from '../../services/graphql.schema';
import Button from '../Forms/Button';
import GraphQlClient from '../../services/graphql';
import moment from 'moment';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        border: 'none',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
        transform: 'translate(-50%, -50%)',
        overflow: 'visible'
    }
};
Modal.setAppElement('#root');

function FiscalpopAutoGlobalDialog({ modalIsOpen, onCloseDialog }: { modalIsOpen: boolean, onCloseDialog: (noGlobalBeforeTS: number) => void }) {

    const [submitting, isSubmitting] = useState(false);
    const [noLinkBefore, setNoLinkBefore] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [dateMax] = useState(moment().endOf('month').valueOf());
    const [error, setError] = useState('');

    const [setNoGlobalBefore] = useMutation(graphqlSchema.PROFILE.SETUP.setGlobalNoGlobalBefore, {
        onCompleted: ({ setGlobalNoGlobalBefore }: { setGlobalNoGlobalBefore: { billGlobalDayEnabled: boolean; noGlobalBeforeTS: number } }) => {
            console.log('Enabled Global TS billing: ', setGlobalNoGlobalBefore);
            GraphQlClient.modifyClientMLprofile(setGlobalNoGlobalBefore);
            isSubmitting(false);
            onCloseDialog(setGlobalNoGlobalBefore.noGlobalBeforeTS);
        },
        onError: () => {
            setError('Hubo un error al asignar la fecha de inicio para Link de facturación');
            isSubmitting(false);
        }
    })

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();
        isSubmitting(true);
        const [year, month, day] = noLinkBefore.split('-').map((s) => parseInt(s));
        const noGlobalBeforeTS = new Date(year, month - 1, day);
        console.log('noLinkBefore: ', noGlobalBeforeTS);
        setNoGlobalBefore({
            variables: {
                noGlobalBeforeTS: noGlobalBeforeTS.getTime()
            }
        })
    }

    const onCancel = () => {
        onCloseDialog(null);
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            style={customStyles}
            contentLabel="FiscalPOP Modal"
        >
            <div id="_FiscalpopDialog">
                <h4>¿A partir de cuando quieres factura global?</h4>
            </div>
            <form id="FiscalpopDialog" onSubmit={onSubmit}>
                <div className="fields">
                    <Input type='date' label="No considerar pedidos antes de" value={noLinkBefore} dateFormat="dddd, MMMM Do YYYY" placeholder="Fecha de inicio" max={dateMax} onChange={setNoLinkBefore} />
                </div>
                <p><span className="accent">Si has llevado tu facturación con el SAT u otra plataforma:</span><br /> Como no sabemos que pedidos han sido facturados externamente, elije el día siguiente al cual iniciaste tu servicio con nosotros, esto evitará facturas duplicadas.</p>
                <div className="actions double">
                    {
                        !submitting ?
                            <p className="error">
                                {error}
                            </p>
                            : <Loading display={true} relativePos={true} svgWidth={'24'} svgHeight={'24'} />
                    }
                    <Button secondary={true} type={'button'} disabled={submitting} handleClick={onCancel}><span>Cancelar</span></Button>
                    <Button primary={true} type={'submit'} disabled={submitting || !!error}><span>Guardar</span></Button>
                </div>
            </form>
        </Modal>
    )
}

export default FiscalpopAutoGlobalDialog;